module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar-container hide-sm",
    class: _vm.isHidden
  }, [_c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.completeInt) + "% complete")]), _vm._v(" "), _c('div', {
    staticClass: "bar-outer"
  }, [_c('div', {
    staticClass: "bar-progress",
    style: (_vm.barSize)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cfd18b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/progressBar.vue
// module id = 593
// module chunks = 1